import Reports from 'components/Report/Campaigns';
import React from 'react';
const CampaignReports = () => {
  return (
      <Reports />
  );
};
export default CampaignReports;
